// js
import React from 'react';
import ReleaseNotes from './ReleaseNotes';
import releaseNotes from '../constants/releaseNotes';

import '../styles/components/WhatsNewModal.scss';

const WhatsNewModalContent = () => {
  return (
    <div className='whats-new-modal-content'>
      <h3 className='title'>What&apos;s New</h3>
      <div className='content'>
        <ReleaseNotes items={releaseNotes} />
      </div>
    </div>
  );
};

export default WhatsNewModalContent;



// WEBPACK FOOTER //
// ./src/components/WhatsNewModalContent.js